export default __webpack_public_path__ + "static/media/salempos.c5fe6097.png";